/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Button, ButtonGroup, StyledModal, ModalActions } from 'sarsaparilla';

interface FavoriteHeartConfirmModalProps {
    closeModal: () => void;
    onConfirmClick: () => void;
    isOpen: boolean;
}

export function FavoriteHeartConfirmModal({
    closeModal,
    onConfirmClick,
    isOpen,
}: FavoriteHeartConfirmModalProps) {
    return (
        <StyledModal
            heading="Remove favorite?"
            size="sm"
            isOpen={isOpen}
            overlayClassName="sui-favorites-modal-wrap"
            onRequestClose={closeModal}
            shouldActionsStickInMobile
            shouldShowCloseButton={false}
        >
            <p>Are you sure you want to remove this favorite?</p>
            <ModalActions>
                <ButtonGroup isFullWidthOnMobile={false} isStretchedToFit>
                    <Button
                        appearance="tertiary"
                        onClick={closeModal}
                        gaTrackingId="445887874628"
                        gaTrackingValue="Cancel Button"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={onConfirmClick}
                        gaTrackingId="445887874628"
                        gaTrackingValue="Remove Favorite Button"
                    >
                        Remove Favorite
                    </Button>
                </ButtonGroup>
            </ModalActions>
        </StyledModal>
    );
}
